"use strict";

import angular from "angular";

import { StringUtils } from "../../utils/string.utils";

const name = "uiMask";
const factory = [
    "$timeout",
    ($timeout) => ({
        restrict: "A",
        require: "ngModel",
        link: function ($scope, $elem, $attr, ngModelCtrl) {
            let templateMask = $attr.uiMask || "";
            function applyMask(value) {
                return StringUtils.stringMaskApply(value, templateMask, {});
            }
            function removeMask(value) {
                return value ? value.replace(/\D/g, "") : "";
            }
            ngModelCtrl.$render = function () {
                let masked = applyMask(ngModelCtrl.$modelValue);
                $elem.val(masked);
            };
            $scope.$watch(
                () => $attr.uiMask,
                (newValue) => {
                    templateMask = newValue;
                    ngModelCtrl.$render();
                }
            );
            $elem.on("input", function () {
                let val = $elem.val();
                let masked = applyMask(val);
                $elem.val(masked);
            });
            ngModelCtrl.$parsers.push(function (viewValue) {
                return removeMask(viewValue);
            });
            ngModelCtrl.$formatters.push(function (modelValue) {
                return applyMask(modelValue);
            });
        }
    })
];
angular.module("nucont.shared").directive(name, factory);
export default { name, factory };
